import Mailing from './Mailing.jsx';

export default Mailing;
